/**
 * Supported log levels.
 * 
 * Default log level is `ERROR`.
 */
export enum MKLogLevel {
    Debug = "debug",
    Error = "error",
    Log = "log",
    Off = "off",
    Warning = "warn"
}